// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Select, MenuItem } from "@mui/material";
import {
  GridFilterItem,
  GridCellParams,
  GridColDef,
} from "@mui/x-data-grid";

// Boolean Filtre Bileşeni
export function BooleanFilterComponent(props) {
  const { item, applyValue, customOptions } = props;

  const handleChange = (event) => {
    // Eğer event.target.value boş bir string ise ve item.value bir boolean ise, 
    // o zaman boolean değeri kullan
    applyValue({
      ...item,
      value: event.target.value === "" && typeof item.value === "boolean" ? item.value : event.target.value,
    });
  };

  return (
    <Select
      value={item.value === false ? false : item.value || ""}
      onChange={handleChange}
      fullWidth
      sx={{ marginTop: 2 }}
    >
      {customOptions?.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
}

// Özelleştirilmiş Boolean Operatörü Oluşturma
export const createBooleanOperator = (customOptions) => ({
  label: "Durum",
  value: "booleanSelect",
  getApplyFilterFn: (filterItem: GridFilterItem, column: GridColDef) => {
    if (!filterItem.field || filterItem.value === undefined || !filterItem.operator) {
      return null;
    }
    return (params: GridCellParams) => {
      return params.value === filterItem.value;
    };
  },
  InputComponent: (props) => (
    <BooleanFilterComponent {...props} customOptions={customOptions} />
  ),
});

